import styled, { css } from 'styled-components';

import { ChatBubbleProps } from './ChatBubble';

const AVATAR_SIZE = 40;

export const ChatBubbleContainer = styled.div<Partial<ChatBubbleProps>>`
	${({ $mine }) => css`
		display: flex;
		flex-direction: column;
		align-items: ${$mine ? 'end' : 'start'};
		position: relative;
	`};
`;

export const ChatBubbleHeader = styled.div``;

export const ChatBubbleUser = styled.div`
	font-size: 15px;
	font-weight: 500;
	color: #222222;
`;

export const ChatBubbleTimestamp = styled.div`
	font-size: 12px;
	color: #556575;
	line-height: normal;
`;

export const ChatBubbleMessage = styled.div<Partial<ChatBubbleProps>>`
	${({ $mine, theme }) => css`
		${$mine ? 'border-radius: 5px 0px 5px 5px;' : 'border-radius: 0px 5px 5px 5px;'}
		${$mine ? 'margin-right:' : 'margin-left:'} calc(12px + ${AVATAR_SIZE}px);
		${$mine && 'text-align: end;'}
		background: ${$mine ? theme.colors.brand.chatBubble : '#F1F1F1'};
		padding: 7px 15px;
		color: ${$mine ? '#FFFFFF' : '#222222'};
		font-size: 15px;
		line-height: 1.21;
		max-width: 70%;
		margin-bottom: 6px;
		overflow-wrap: break-word;
	`};
`;
